import Footer from './Footer';
import Header from './Header';
import Home from './Home';
import SideNav from './SideNav';

function PageHome() {
    return (
        <div className="wrapper">
            <Header></Header>
            <SideNav></SideNav>
            <Home />
            <Footer />
        </div>
    );
}

export default PageHome;
